import React, { Fragment, useState, useEffect } from 'react';
import { Row } from 'reactstrap';
import moment from 'moment';


const StagesManagement = ({ idActualStage, stages = [], idAgenda, idCita, servicesSelectedDuration = 0, intervalStage = 0, handlerIdsStagesSelection }) => {

    const stageByAppointment = stages.find(stage => stage.id_cita === idCita);
    const [idsSelectedStagesByUser, setIdsSelectedStagesByUser] = useState([idActualStage]);
    const [timeBySelectdStages, setTimeBySelectdStages] = useState(intervalStage);
    const [stagesJorn, setStagesJorn] = useState([])

    useEffect(() => {
        if (stages.length)
            setStagesJorn(stages)
    }, [stages])


    const defineStilesStages = (priority, idDataEvent) => {
        let findStage = stages.find(stages => stages.id === idDataEvent);
        return {
            border: idDataEvent === idActualStage || idsSelectedStagesByUser.includes(idDataEvent) ? '0.2em solid #2889dd' : definePriorityStage(priority),
            borderRadius: '0.5em',
            margin: '0.2em',
            padding: '0.5em 1em',
            cursor: idDataEvent === idActualStage ? 'pointer' : 'default',
            pointerEvents: idDataEvent === idActualStage ? 'none' : findStage ? findStage.disabled ? 'none' : 'auto' : 'auto',
            opacity: findStage ? findStage.disabled ? '0.4' : '1' : '1',
            backgroundColor: idDataEvent === idActualStage || idsSelectedStagesByUser.includes(idDataEvent) ? '#2889dd' : '#fff',
            color: idDataEvent === idActualStage || idsSelectedStagesByUser.includes(idDataEvent) ? '#fff' : '#2889dd',
        }
    }

    const definePriorityStage = (priority) => {
        switch (priority) {
            case 'Reservada':
                return '0.2em solid #fd7e14';
            case 'Cumplida':
                return '0.2em solid #28a745';
            case 'Incumplida':
                return '0.2em solid #f6da6e';
            case 'Emergencia':
                return '0.2em solid #dc3545';
            case 'Disponible':
                return '0.2em solid #70bbfd';
            case 'Inactivar':
                return '0.2em solid #787985';

            default:
                return '#787985';
        }
    }

    const handlerOnSelectStage = (stage) => {
        if (idsSelectedStagesByUser.includes(stage.id)) {
            let organizedIdsSelectedStages = idsSelectedStagesByUser.map(num => num).sort((a, b) => a - b);
            if (organizedIdsSelectedStages[0] === stage.id || organizedIdsSelectedStages[organizedIdsSelectedStages.length - 1] === stage.id) {
                let newIds = idsSelectedStagesByUser.filter(idStage => idStage !== stage.id);
                setIdsSelectedStagesByUser(newIds);
                setTimeBySelectdStages(prevState => prevState - stage.intervalo);
                handlerIdsStagesSelection(stage.id, 'REMOVE');
                setStagesJorn(defineDisabledStages(stage, 'REMOVE'));
            }
        } else {
            setTimeBySelectdStages(prevState => prevState + stage.intervalo);
            setIdsSelectedStagesByUser(prevState => [...prevState, stage.id]);
            handlerIdsStagesSelection(stage.id, 'ADD');
            setStagesJorn(defineDisabledStages(stage, 'ADD'));
        }
    }

    const defineDisabledStages = (stage, action) => {
        let findIdxStageSelected = stagesJorn.findIndex(stageJorn => stageJorn.id === stage.id);
        let newStagesJornTwo = stagesJorn;

        if (action === 'ADD') {
            if (newStagesJornTwo[findIdxStageSelected - 1]) {
                newStagesJornTwo[findIdxStageSelected - 1].disabled = newStagesJornTwo[findIdxStageSelected - 1].id === idActualStage ? true : false;
            }
            if (newStagesJornTwo[findIdxStageSelected + 1]) {
                newStagesJornTwo[findIdxStageSelected + 1].disabled = newStagesJornTwo[findIdxStageSelected + 1].id === idActualStage ? true : false;
            }
        } else {
            newStagesJornTwo[findIdxStageSelected].disabled = newStagesJornTwo[findIdxStageSelected].id === idActualStage ? true : false;
            if (newStagesJornTwo[findIdxStageSelected - 1]) {
                newStagesJornTwo[findIdxStageSelected - 1].disabled = newStagesJornTwo[findIdxStageSelected - 1].id === idActualStage ? true : idsSelectedStagesByUser.includes(newStagesJornTwo[findIdxStageSelected - 1].id) ? false : true;
            }
            if (newStagesJornTwo[findIdxStageSelected + 1]) {
                newStagesJornTwo[findIdxStageSelected + 1].disabled = newStagesJornTwo[findIdxStageSelected + 1].id === idActualStage ? true : idsSelectedStagesByUser.includes(newStagesJornTwo[findIdxStageSelected + 1].id) ? false : true;
            }
        }

        return newStagesJornTwo;
    }

    return (
        <Fragment>
            {(!!stagesJorn.length && !idCita) &&
                <Row>
                    {!!servicesSelectedDuration &&
                        <Fragment>
                            <div className='flex-column-start' style={{ width: '100%' }}>
                                <div className='titles-segment-appointment-mod'>
                                    <h6>Duración Servicios: {servicesSelectedDuration} minutos</h6>
                                </div>
                                <div className='titles-segment-appointment-mod' style={{ width: '100%' }}>
                                    <div className='flex-start-elem' style={{ width: '100%' }}>
                                        <div>
                                            <h6>Duración Cita: {timeBySelectdStages} minutos</h6>
                                        </div>
                                        {timeBySelectdStages < servicesSelectedDuration && <div style={{ marginLeft: 'auto' }}> <span>El tiempo seleccionado es menor a la duración de los servicios</span></div>}
                                    </div>
                                </div>
                            </div>
                        </Fragment>
                    }
                    <div className='flex-row-center' style={{ flexWrap: 'wrap' }}>
                        {stagesJorn.map((stage, idx) => (
                            <div
                                key={stage.id}
                                style={defineStilesStages(stage.priority, stage.id, idx)}
                                onClick={() => handlerOnSelectStage(stage)}
                                disabled={stage.disabled}
                            >{moment(stage.start).format('HH:mm')} - {moment(stage.end).format('HH:mm')}
                            </div>
                        ))
                        }
                    </div>
                </Row>
            }
            {(stageByAppointment && idCita) &&
                <Row>
                    <div className='titles-segment-appointment-mod'><p>Inicio: {moment(stageByAppointment.start).format('HH:mm')} | Fin: {moment(stageByAppointment.end).format('HH:mm')}</p></div>
                </Row>
            }
        </Fragment>
    )
}
export default StagesManagement